import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import TimeIcon from "@/components/icons/TimeIcon"
import XIcon from "@/components/icons/XIcon"
import { storeRef } from "@/components/providers/StoreProvider"
import { cabinClasses } from "@/constants/flight/cabinClass"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { TypeAirport } from "@/lib/redux/features/flight/type"

import { Button, Col, Row } from "antd"
import { FC } from "react"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useTranslation } from "react-i18next"

type SearchingFlightItemProps = {
  from: TypeAirport,
  to: TypeAirport,
  dateTo: string,
  dateFrom: string,
  cabinClass: any,
  onChoose: () => void
}

const SearchingFlightItem: FC<SearchingFlightItemProps> = ({ from, to, cabinClass, dateFrom, dateTo, onChoose }) => {
  const { getAirportCityName, getValidDayjs } = useTETranslation()
  const fromValidDayjs = getValidDayjs(dateFrom)
  const toValidDayjs = getValidDayjs(dateTo)
  const selectedFligthInputIndex = useAppSelector(state => state.flight.selectedFligthInputIndex)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  return (
    <Row
      className="select-placement__recent-item"
      // onClose={() => {
      //   const newRecentlySearch = { ...currentlyFlights }
      //   delete newRecentlySearch[code]
      //   dispatch(flightActions.onUpdateCurrentlyFlight({ currentlyFlights: newRecentlySearch }))
      // }}
      onClick={() => {
        dispatch(flightActions.selectFromAirport({ indexInputFlight: selectedFligthInputIndex, fromAirport: from }))
        dispatch(flightActions.selectToAirport({ indexInputFlight: selectedFligthInputIndex, toAirport: to }))
        // dispatch(flightActions.changeDateTo({ indexInputFlight: selectedFligthInputIndex, dateTo: dateTo }))
        // dispatch(flightActions.changeDateFrom({ indexInputFlight: selectedFligthInputIndex, dateFrom: dateFrom }))
        dispatch(flightActions.selectCabinClass(cabinClass))
        onChoose()
      }}
      style={{ paddingBlock: '1rem', paddingInline: '1.2rem', cursor: 'pointer', userSelect: 'none' }}
    >
      <Col span={24}>
        <Row wrap={false} gutter={[10, 10]} align='middle'>
          <Col>
            <TimeIcon style={{ fontSize: '2rem' }} />
          </Col>
          <Col flex={1}>
            <Row wrap={false}>
              <Col flex={1}>
                <Title style={{ fontWeight: 'normal', margin: 0 }} level={5}>
                  {getAirportCityName(from) || from.country} ({from.code}) → {getAirportCityName(to) || to.country} ({to.code})
                </Title>
              </Col>
              <Col>
                <Button
                  type='text'
                  icon={<XIcon />}
                  shape='circle'
                  onClick={(e) => {
                    e.stopPropagation()
                    const currentlyFlights = storeRef.current?.getState().flight.currentlyFlights || {}
                    const newRecentlySearch = { ...currentlyFlights }
                    delete newRecentlySearch[`${from.code}${to.code}`]
                    dispatch(flightActions.onUpdateCurrentlyFlight({ currentlyFlights: newRecentlySearch }))
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[10, 10]} align='middle'>
          <Col>
            <TimeIcon style={{ fontSize: '2rem', opacity: 0, color: 'transparent' }} />
          </Col>
          <Col flex={1}>
            <Text type='secondary'>{fromValidDayjs.format('DD/MM/YYYY')} - {toValidDayjs.format('DD/MM/YYYY')} | {(cabinClasses as any)[cabinClass]?.name ? t((cabinClasses as any)[cabinClass].name) : t("common.all")}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default SearchingFlightItem